import { trimEndSlash, makeTokenRequest, getTokenRequestParameters } from "../../helpers";
import { SEAMLESS_ENDPOINTS, RequestMethods } from "../../constants";
export class SeamlessRequestService {
    constructor(url, operatorAuthTokenId, ajaxService, storage) {
        if (!operatorAuthTokenId) {
            throw new Error("Invalid operatorAuthTokenId");
        }
        this.baseAnynomousApiUrl = url;
        this.ajaxService = ajaxService;
        this.operatorAuthTokenId = operatorAuthTokenId;
        this.storage = storage;
    }
    onLoginTokenSuccess(response) {
        const token = this.getParsedToken(response);
        this.storage.setToken(token);
        return token;
    }
    getParsedToken(response) {
        let parsedResponse = JSON.parse(response);
        return parsedResponse.jwt || parsedResponse.Jwt;
    }
    getAnonymousToken() {
        return makeTokenRequest(this.ajaxService, getTokenRequestParameters(`${trimEndSlash(this.baseAnynomousApiUrl)}/${SEAMLESS_ENDPOINTS.ANONYMOUS}`, this.getParsedToken.bind(this), "", this.getRequestOptions()));
    }
    getLoginToken(params) {
        return makeTokenRequest(this.ajaxService, getTokenRequestParameters(`${trimEndSlash(this.baseAnynomousApiUrl)}/${SEAMLESS_ENDPOINTS.LOGIN}`, this.onLoginTokenSuccess.bind(this), this.getLoginRequestBody(params), this.getRequestOptions()));
    }
    getLoginRequestBody(params) {
        return `{ token: ${params.sToken} }`;
    }
    getRequestOptions() {
        return {
            headers: {
                domainId: this.operatorAuthTokenId
            },
            method: RequestMethods.POST
        };
    }
}
//# sourceMappingURL=SeamlessRequestService.js.map